import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { applyUpdate, getUpdateAvailable } from '../pwa';

const Wrap = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  padding: 12px;
  padding-top: calc(12px + var(--safe-top));
  padding-left: calc(12px + var(--safe-left));
  padding-right: calc(12px + var(--safe-right));
  background: linear-gradient(to bottom, var(--tg-bg) 0%, rgba(245, 247, 251, 0) 100%);
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: var(--tg-radius);
  border: 1px solid rgba(42, 158, 241, 0.25);
  background: rgba(42, 158, 241, 0.10);
  box-shadow: var(--tg-shadow);
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: var(--tg-text);
`;

const Sub = styled.div`
  font-size: 12px;
  color: var(--tg-muted);
`;

const Button = styled.button`
  border: none;
  border-radius: var(--tg-radius-sm);
  background: var(--tg-accent);
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 700;
`;

const UpdateBanner = () => {
  const [available, setAvailable] = useState(getUpdateAvailable());

  useEffect(() => {
    const handler = (e) => {
      setAvailable(Boolean(e?.detail?.available));
    };

    window.addEventListener('connect-sw-update', handler);
    return () => window.removeEventListener('connect-sw-update', handler);
  }, []);

  if (!available) return null;

  return (
    <Wrap>
      <Card>
        <Text>
          <Title>نسخه جدید آماده است</Title>
          <Sub>برای دریافت آخرین نسخه، به‌روزرسانی کنید.</Sub>
        </Text>
        <Button
          type="button"
          onClick={() => {
            applyUpdate();
          }}
        >
          به‌روزرسانی
        </Button>
      </Card>
    </Wrap>
  );
};

export default UpdateBanner;
